export default __webpack_public_path__ + "static/media/mele.06ed26d0.mp3";